// extracted by mini-css-extract-plugin
export var alert = "styles-module--alert--a4eb9";
export var collapsed = "styles-module--collapsed--cd0c7";